import { Fragment, useState, useEffect, useCallback } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Loading from "../Components/Loading";
import { useParams } from "react-router-dom";
import Api from "../Services/Api";
import { useTranslation } from "react-i18next";
import CaloriesLineChart, {
  LineChartType,
} from "../Components/CaloriesLineChart";
import { ParseCaloriesData } from "../Helpers/ParseCaloriesData";
import EmptyData from "../Components/EmptyData";

enum RequestStatus {
  pending,
  requesting,
  error,
  success,
}

type Calories = {
  lineChart: LineChartType;
  starsChart: {
    stars: number;
    average: number;
    title: string;
  };
};

const CaloriesChart = () => {
  const { t } = useTranslation();
  const { dynamicId } = useParams();

  const [data, setData] = useState<Calories | undefined>(undefined);
  const [emptyData, setEmptyData] = useState(false);
  const [status, setStatus] = useState<RequestStatus>(RequestStatus.pending);

  const handleData = useCallback(
    (dynamicId: string) => {
      setStatus(RequestStatus.requesting);
      const api = new Api();
      api
        .getResource(dynamicId)
        .then(async (response) => {
          setStatus(RequestStatus.success);
          if (response.length === 0) {
            setEmptyData(true);
            return;
          }
          if (response !== undefined) {
            const parsedData = await ParseCaloriesData(response, t);
            setData(parsedData);
          }
        })
        .catch((error) => {
          setStatus(RequestStatus.error);
        });
    },
    [t]
  );

  useEffect(() => {
    if (dynamicId !== undefined && status === RequestStatus.pending) {
      handleData(dynamicId);
    }
  }, [status, dynamicId, handleData]);

  useEffect(() => {
    window.rudderanalytics.page("Calories Chart");
  }, []);

  return (
    <Fragment>
      <Container className="mt-4">
        {status === RequestStatus.requesting ? (
          <Loading />
        ) : emptyData ? (
          <EmptyData parameter="calories" />
        ) : data === undefined ? (
          <div></div>
        ) : (
          <Fragment>
            <CaloriesLineChart lineChart={data.lineChart} />
            <br />
            <Row>
              <Col
                xl={{ span: 4, offset: 4 }}
                lg={{ span: 6, offset: 3 }}
                md={{ span: 8, offset: 2 }}
                xs={{ span: 11, offset: 1 }}
              ></Col>
            </Row>
            <br />
            <br />
          </Fragment>
        )}
      </Container>
    </Fragment>
  );
};

export default CaloriesChart;
